import { Button, TextField } from "@mui/material";
import axios from "axios";
import { forwardRef, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { isValidPhoneNumber } from 'react-phone-number-input';
import PhoneInput from 'react-phone-number-input';
import { authData } from "./GetAuth";

const CustomInput = forwardRef((props, ref) => (<TextField {...props} inputRef={ref} id="outlined-basic" label="Phone*" variant="outlined" />));

const UpdateProfileForm = ({ setFormOpenUpdateProfile, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, userProfileData }) => {
    const [auth, setAuth] = useState(authData());
    const API_TOKEN = auth?.api_token;

    const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
        mode: 'onChange',
        defaultValues: {
            user_type: ''
        }
    });

    useEffect(() => {
        if (auth) {
            setValue('name', auth?.name);
            setValue('email', auth?.email);
            setValue('phone', auth?.phone);
            setValue('user_type', auth?.user_type);
        }
    }, [userProfileData, setValue, auth])

    const onSubmit = (data) => {
        setLoading(true);
        setFormOpenUpdateProfile(false);

        axios.post(process.env.REACT_APP_API_URL + 'v1/users/update-profile/' + auth?.id, data, {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`
            }
        }).then(response => {
            setLoading(false);

            if (response.data.status === 'SUCCESS') {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType('success');
                const resData = response.data.data;

                setAuth(resData);
                localStorage.setItem('authData', JSON.stringify(resData));
            }

            if (response.data.status === 'ERROR') {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType('error');
            }
        }).catch(error => {
            setLoading(false);
            if (error && error.response && error.response.data && error.response.data.messages) {
                setSnackbarOpen(true);
                setSnackbarMessage(error.response.data.messages);
                setSnackbarType('error');
            }
        });
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ width: '500px', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
            <div className={`FormHalfGroup`}>
                <Controller
                    control={control}
                    {...register('name', { required: 'This field is Required' })}
                    render={({ field }) => <TextField {...field} label="Full Name*" variant="outlined" />}
                />
                {errors.name && <span className={`ErrorM`}>{errors?.name?.message}</span>}
            </div>
            <div className={`FormHalfGroup`}>
                <Controller
                    control={control}
                    {...register('email', {
                        required: 'This field is Required', pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address"
                        }
                    })}
                    readOnly={true}
                    render={({ field }) => <TextField {...field} label="Email*" variant="outlined" disabled={true} />}
                />
                {errors.email && <span className={`ErrorM`}>{errors?.email?.message}</span>}
            </div>
        </div>
        <div style={{ width: '500px', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
            <div className={`FormHalfGroup`}>
                <Controller
                    control={control}
                    {...register('phone', { required: 'This field is Required', validate: isValidPhoneNumber })}
                    render={({ field }) => <PhoneInput {...field} defaultCountry="GB" inputComponent={CustomInput} />}
                />
                {(errors.phone && errors.phone.type !== "validate") && <span className={`ErrorM`}>{errors.phone.message}</span>}
                {(errors.phone && errors.phone.type === "validate") && <span className={`ErrorM`}>Please enter valid phone</span>}
            </div>
        </div>

        <div className={`FormButtonArea`}>
            <Button className={`CancelBU`} onClick={(e) => setFormOpenUpdateProfile(false)}>Cancel</Button>
            <Button className={`SubmitBU`} type="submit">{userProfileData ? 'Update' : 'Add'}</Button>
        </div>
    </form>);
}

export default UpdateProfileForm;